import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { CreateArtifactContext } from "../../../context/CreateArtifactContext";
import { useNavigationBar } from "../../../context/NavigationContext";
import { ContentState } from "../../../models/SKArtifact";
import LoadingPopup from "../../channels/create/LoadingPopup";
import { isEditable } from "@testing-library/user-event/dist/utils";
import { ContentAgeRestriction } from "../../../api/enums";

const ageData = [
  {
    id: 1,
    title: "Age 4+",
    age: ContentAgeRestriction.fourPlus,
    description:
      "*Content suitable for children aged 4 and older.* Contains minimal or no violence, mild language, and positive themes. Appropriate for young audiences.",
  },
  {
    id: 2,
    title: "Age 9+",
    age: ContentAgeRestriction.ninePlus,
    description:
      "*Not suitable for children under the age of 9.* Contains mild or infrequent occurrences of mature or suggestive content, moderate language and themes.",
  },
  {
    id: 3,
    title: "Age 12+",
    age: ContentAgeRestriction.twelvePlus,
    description:
      "*Not suitable for children under the age of 12.* Contains stronger or more frequent occurrences of mature or suggestive content, stronger language and complex themes.",
  },
  {
    id: 4,
    title: "Age 17+",
    age: ContentAgeRestriction.seventeenPlus,
    description:
      "*Not suitable for children under the age of 17.* Contains frequent or intense occurrences of mature or suggestive content, strong language and mature themes.",
  },
];

function AgeRating() {
  const { contentData, updateContentData, isEditable } = useContext(CreateArtifactContext);
  const [isLoading, setIsLoading] = useState(false);
  const { setNavProps } = useNavigationBar();
  const navigate = useNavigate();
  const [editable, setEditable] = useState<boolean>(true);
  useEffect(() => {
    if (contentData.status === ContentState.DRAFT) {
      setEditable(true);
    } else {
      setEditable(false);
    }
  }, [contentData]);

  useEffect(() => {
    setNavProps({
      backArrow: false,
      title: "Content",
      subtitle: "Channel",
      buttonTitle: "Done",
      filterOption: false,
      enableLink: contentData.age ? true : false,
      onFilter: () => {},
      onNext: isEditable ? () => navigate(-1) : undefined,
      onClose: () => navigate(-1),
      getActionItems: undefined,
      onEdit: undefined,
    });
  }, [setNavProps, contentData, isEditable]);

  let element = <img id="icon-rounds" src={`/icons/${editable ? "CheckFilled.png" : "CheckInactive.png"}`} className="topic-checkbox" alt="" />;

  const renderDescription = (description: string) => {
    return description.split(/(\*.*?\*)/g).map((part, index) => {
      if (part.startsWith("*") && part.endsWith("*")) {
        return (
          <span key={index} className="font-bold">
            {part.slice(1, -1)}
          </span>
        );
      }
      return part;
    });
  };

  return (
    <div className="bg-white">
      <LoadingPopup isLoading={isLoading} />
      <div className="flex flex-col">
        <div className="flex flex-col w-full mb-5">
          <div className="flex flex-col w-full mb-5">
            <label className="title_inner_page">Choose the Age Rating of your Content</label>
            <label className="notes-class-content">Choose the age rating based on the appropriateness of your content for children.</label>
            <div className="px-[1px] flex flex-col w-full pt-[15px]">
              <ul className="space-y-4">
                {ageData.map(item => (
                  //{items.map((item, index) => (
                  <li
                    onClick={() => {
                      editable && updateContentData({ ...contentData, age: item.age });
                    }}
                    key={item.id}
                    className="flex bg-white border-b age-certificate-divider-item"
                  >
                    <img
                      src={contentData.age === item.age ? "/svg/circlechecked.svg" : "/svg/circle.svg"}
                      alt={item.title}
                      className="object-cover w-5 h-5"
                    />
                    <div className="flex-1 ml-[15px] space-4">
                      <div className="content-subtitle-text">{item.title}</div>
                      <div className="notes-class-light mb-[15px]">{renderDescription(item.description)}</div>
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AgeRating;
